import Header from "../components/Header";
function Template(props) {
    return (
        <div className="flex flex-col w-full justify-start">
            <div className="flex flex-col h-fit items-center justify-start">
                <Header title={props.title} back={props.back} settings={props.settings} />            
            </div>
            {props.children}
        </div>
    );
}
  
export default Template;